<template>
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.392 17.25H20.25v10.5h-4.5v-10.5h-3v-3h3v-1.746c0-1.649.528-4.227 3.975-4.227l3.525.009v3.459h-2.112c-.366 0-.888.186-.888.97v1.535h3.508l-.366 3zM18 0C8.074 0 0 8.075 0 18s8.074 18 18 18c9.925 0 18-8.075 18-18S27.925 0 18 0z" fill="#033D89" fill-rule="evenodd"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFacebook',
};
</script>

